import { AppLayout } from "layout";
import { HandoutOverViewData } from "../components";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ContentsService } from "services/ContentsService";

type Props = {};

type ContentData = {
  id: string;
  title: string;
  description: string;
  [key: string]: any; // Add other fields as required
};

const HandoutOverViewContainer = (props: Props) => {
  const { id } = useParams();
  const [data, setData] = useState(null);

  //   useEffect(() => {
  //     const fetchContent = async () => {
  //       try {
  //         // Fetch content using Firebase
  //         const contentData = await ContentsService.getContentById(id);
  //         setData(contentData);
  //       } catch (err) {
  //         console.error("Error fetching content data:", err);
  //       }
  //     };

  //     if (id) {
  //       fetchContent();
  //     }
  //   }, [id]);

  return (
    <AppLayout>
      <HandoutOverViewData />
    </AppLayout>
  );
};

export default HandoutOverViewContainer;
